import { images } from "../../Constants/imageslinks";

const timeCardImages = [
  {
    image: images.welcomeCardImage1,
    alt: "image1",
  },
  {
    image: images.welcomeCardImage2,
    alt: "image2",
  },
  {
    image: images.welcomeCardImage3,
    alt: "image3",
  },
  {
    image: images.welcomeCardImage4,
    alt: "image4",
  },
];

const cardImages = timeCardImages.map((image, index) => (
  <img
    key={index}
    src={image.image}
    alt={image.alt}
    className="w-full md:max-w-[16vw] 3xl:max-w-[306px]"
  />
));

function WelcomeScreenCards() {
  return (
    <div className="bg-primary100">
      <div className="3xl:container 3xl:mx-auto lg:px-[3.88vw] 3xl:px-[75px] md:px-8 px-4 lg:py-[72px] py-8 flex flex-col items-center lg:gap-[72px] gap-8">
        <p className="font-light md:text-2xl text-xl md:leading-6 leading-[30px] md:text-black text-secondary100">
          Get started in few minutes. Simple, hassle-free setup.
        </p>
        <div className="grid md:grid-cols-4 grid-cols-2 md:gap-4 gap-3  md:max-w-[68vw] 3xl:max-w-[1306px]">
          {cardImages}
        </div>
      </div>
    </div>
  );
}

export default WelcomeScreenCards;
